import React from 'react'

const BASE_CLASS = 'w-full px-4 py-10 text-center font-roboto services-box flex flex-col gap-8 justify-center       rounded-[10px] md:w-[45%] lg:w-[23%] h-80 md:h-96';

// animation : 'aos' (defaut, revele au scroll) ou 'css' (joue au montage).
// 'css' est necessaire pour les listes filtrees, ou AOS ne sait pas suivre
// les noeuds ajoutes/retires par React.
export default function Cards({ titre, texte, image, animation = 'aos', delay = 0}) {
  const cssAnimation = animation === 'css';

  const animationProps = cssAnimation
    ? { style: { animationDelay: `${delay}ms` } }
    : { 'data-aos': 'fade-up', 'data-aos-duration': '1500' };

  return (
    <div className={cssAnimation ? `${BASE_CLASS} card-anim` : BASE_CLASS} {...animationProps}>
      <h2 className='font-bold text-lg md:text-2xl text-gray-800 font-roboto align-first-line'>{titre}</h2>
      {image ? (
        <img src={image} className='mx-auto' alt="" style={{ width: '30%' }} />
      ) : null}
      <div className='h-32 flex items-center'>
        <p className='paragraph text-center align-first-line'>{texte}</p>
      </div>
    </div>
  )
}
